import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { warehouseexecApi, type FulfilmentJob } from '../../api/warehouseexec';

export function PackingDashboardPage() {
  const [jobs, setJobs] = useState<FulfilmentJob[]>([]);
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void warehouseexecApi.listJobs().then(setJobs).catch((e) => setError(String(e)));
  }, []);

  async function packFirst() {
    const job = jobs.find((j) => j.status === 'packing') ?? jobs[0];
    if (!job) return;
    setMsg('Starting pack session…');
    try {
      const session = await warehouseexecApi.startPacking({ job_id: job.id, worker_id: 'packer-1' });
      const pkg = await warehouseexecApi.completePacking({
        session_id: session.id, weight: 1.2, length: 0.3, width: 0.2, height: 0.15,
      });
      setMsg(`Packed — carton ${pkg.carton_type}, barcode ${pkg.barcode ?? 'n/a'}`);
      setJobs(await warehouseexecApi.listJobs());
    } catch (e) {
      setError(String(e));
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/warehouse" className="text-sm text-slate-600 hover:underline">← Warehouse hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Packing dashboard</h1>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <button type="button" onClick={() => void packFirst()} disabled={!jobs.length}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white disabled:opacity-50">
        Start & complete pack for next job
      </button>
      <ul className="mt-6 space-y-2">
        {jobs.map((j) => (
          <li key={j.id} className="rounded-lg border p-3 text-sm">
            <span className="font-mono">{j.order_id}</span> — {j.status} ({j.pick_strategy})
          </li>
        ))}
      </ul>
    </div>
  );
}
